import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import { LocalizationContext } from 'contexts/Localization'
import { Text } from 'styles/components/typography'

import { SectionWrapperStyled } from './styles'

/**
 * DHowInterpreting
 *
 * @param {object} props - properties of component
 * @returns {node} DHowInterpreting
 */
const WHowInterpreting = ({ data, index, isSquareHidden }) => {
  const { colors } = React.useContext(ThemeContext)
  const { paths } = React.useContext(LocalizationContext)

  return (
    <SectionWrapperStyled
      image={`${paths.shared}/cover_lab_servers`}
      withOverlay={true}
      classNameInner="d-how-interpreting__inner pb-4"
    >
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={data.title}
        index={index}
        squareColor={colors.lilac}
        lineColor="light"
        textColor="light"
      >
        <div className="row">
          <div className="col-12 col-md-5 col-lg-5 offset-md-1">
            <Text
              className="with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
        </div>
      </HowToBlock>
    </SectionWrapperStyled>
  )
}

WHowInterpreting.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSquareHidden: PropTypes.bool,
}

WHowInterpreting.defaultProps = {
  isSquareHidden: false,
}

export default WHowInterpreting
